'use strict';

import Bowser from 'bowser';

export class EnvironmentService {
  private static readonly _instance = new EnvironmentService();
  static get instance() {
    return EnvironmentService._instance;
  }

  private browser = Bowser.getParser(window.navigator.userAgent);

  private constructor() {
    // Do nothing.
  }

  /**
   * Returns a value indicating whether the current browser is supported.
   */
  isValidBrowser() {
    // this.browser.satifies can not be used because user agent from WebView (iOS) doesn't include browser version.
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 13_7 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148"
    //
    // For now, support all versions of specified browsers.
    const acceptedBrowserAliases = ['chrome', 'edge', 'safari'];
    for (const browserAlias of acceptedBrowserAliases) {
      if (this.browser.isBrowser(browserAlias, true)) {
        return true;
      }
    }

    return false;
  }

  /**
   * Returns name of browser.
   */
  getBrowserName() {
    return this.browser.getBrowserName();
  }

  /**
   * Returns a value representing the current environment.
   */
  getEnvironment(): 'development' | 'production' | 'test' {
    return process.env.NODE_ENV! as 'development' | 'production' | 'test';
  }

  /**
   * Returns a value indicating whether the current platform is a mobile platform.
   */
  isMobilePlatform() {
    return this.browser.getPlatformType() === 'mobile';
  }

  /**
   * Returns a value indicating whether the current environment is the production environment.
   */
  isProduction() {
    return this.getEnvironment() === 'production';
  }
}
